import React from 'react';
import { UID } from 'react-uid';

const XIcon = ({
  title = 'Close',
  decorative = true,
  className,
  color,
  size,
}) => (
  <UID>
    {(uid) => (
      <div style={{ color, width: size, height: size }} className={className}>
        <svg
          role="img"
          aria-hidden={decorative}
          aria-labelledby={uid}
          height="100%"
          width="100%"
          viewBox="0 0 7 7"
        >
          <title id={uid}>{title}</title>
          <path
            fill="currentColor"
            d="M6.7 5.225c.4.4.4 1 0 1.4-.2.3-.5.3-.7.3-.2 0-.5-.1-.7-.3l-1.8-1.7-1.8 1.8c-.2.2-.4.2-.7.2-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l1.8-1.8-1.8-1.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l1.8 1.8 1.8-1.8c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-1.8 1.8 1.8 1.7z"
          />
        </svg>
      </div>
    )}
  </UID>
);

export default XIcon;
